<div class="container-fluid pt-4">
    <div class="row">
        <div class="col-md-5 col-6 ">
            <a routerLink="/home" class="primary-textcolor nav-home">
                <img src="../../assets/images/icons/Back.svg" class="mr-2" style="width: 15px;height: 15px" alt="back">
                <span class="d-none d-md-inline">Back to My Policies</span>
                <span class="d-md-none">My Policies</span>
            </a>
        </div>
    </div>
    <div class="my-profile">
    <span class="accordion-heading primary-textcolor"> <img src="../../assets/images/icons/user.svg"
                                                            style="width:20px;height:20px;" alt="my profile">
      My Proﬁle</span>
    </div>
    <accordion class="profile-details" [closeOthers]="oneAtATime">
        <accordion-group [panelClass]="profileSection" class="mb-4 acc-background" [isOpen]="panelList[0].value"
                         (isOpenChange)="onPanelValueChange($event, 0)" #personalprofile>
            <div accordion-heading class="clearfix">
                <span class="accordion-heading primary-textcolor">Personal</span>
                <span [ngClass]="!personalprofile?.isOpen ? 'icon-open': 'icon-close'"
                      class="d-md-inline-block float-right"></span>
            </div>
            <div class="row">
                <div class="col-md-6 offset-md-6 col-xl-5 offset-xl-7 text-right mb-4">
          <span class="text-alerts d-md-inline">
            <span *ngIf="primaryMobile && !optOutSmsAlert && textNotificationSelected">Text notifications are sent to
              <span class="primary-textcolor pr-4">{{ preferredMobile }} </span></span>
            <span (click)="phoneNumNotification('change');" class="icon-Change-Edit primary-textcolor"
                  *ngIf="mobileType.length>1 && primaryMobile && !optOutSmsAlert && textNotificationSelected"></span>
            <a (click)="phoneNumNotification('change');" class="primary-textcolor pl-2 d-none d-lg-inline"
               *ngIf="mobileType.length>1 && primaryMobile && !optOutSmsAlert && textNotificationSelected">Change</a>
          </span>
                </div>
            </div>
            <form [formGroup]="userProfileForm">
                <div class="form-group row">
                    <div class="col-xl-2 col-md-3 offset-md-1 pt-md-2 col-form-label col-12">First Name</div>
                    <div class="col-xl-4 col-md-6 col-12">
                        <input type="text" class="form-control mt-md-0 mt-2 pl-3" placeholder="First Name"
                               name="first-name"
                               formControlName="firstName" (keyup)="checkUserEnteredData()" maxlength="50">
                        <div class="text-danger pt-2"
                             *ngIf="(userProfileFormSubmitted||userProfileForm.controls['firstName'].touched)&&userProfileForm.controls['firstName'].hasError('required')">
                            First name is required
                        </div>
                        <div class="text-danger pt-2"
                             *ngIf="(userProfileFormSubmitted||userProfileForm.controls['firstName'].touched)&&userProfileForm.controls['firstName'].hasError('pattern')">
                            Other than alphabet letters, the Name fields can only include the following characters:
                            apostrophe,
                            comma,
                            period or hyphen.
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl-2 col-md-3 offset-md-1 pt-md-2 col-form-label col-12"> Last Name</div>
                    <div class="col-xl-4 col-md-6 col-12">
                        <input type="text" class="form-control mt-md-0 mt-2 pl-3" placeholder="Last Name"
                               name="last-name"
                               formControlName="lastName" (keyup)="checkUserEnteredData()" maxlength="50">
                        <div class="text-danger pt-2"
                             *ngIf="(userProfileFormSubmitted||userProfileForm.controls['lastName'].touched)&&userProfileForm.controls['lastName'].hasError('required')">
                            Last name is required
                        </div>
                        <div class="text-danger pt-2"
                             *ngIf="(userProfileFormSubmitted||userProfileForm.controls['lastName'].touched)&&userProfileForm.controls['lastName'].hasError('pattern')">
                            Other than alphabet letters, the Name fields can only include the following characters:
                            apostrophe,
                            comma,
                            period or hyphen.
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl-2 col-md-3 offset-md-1 pt-md-2 col-form-label col-12"> Email</div>
                    <div class="col-xl-4 col-md-6 col-12">
                        <input type="email" class="form-control mt-md-0 mt-2 pl-3" formControlName="emailId"
                               (keypress)="restrictBackspace($event)" aria-label="emailId"
                               (keyup)="checkUserEnteredData()" maxlength="128"
                               pattern="^[\u00C0-\u1FFF\u2C00-\uD7FF\w._%+-]+@[\u00C0-\u1FFF\u2C00-\uD7FF\w.-]+\.[\u00C0-\u1FFF\u2C00-\uD7FF\w]{2,5}$">
                        <div class="text-danger pt-2"
                             *ngIf="(userProfileFormSubmitted||userProfileForm.controls['emailId'].touched)&&userProfileForm.controls['emailId'].hasError('required')">
                            This is required field
                        </div>
                        <div class="text-danger pt-2"
                             *ngIf="(userProfileFormSubmitted||userProfileForm.controls['emailId'].touched)&&userProfileForm.controls['emailId'].hasError('pattern')">
                            Please enter a valid e-mail address
                        </div>
                    </div>
                </div>
                <div class="form-group row" formArrayName="newPhones">
                    <div class="col-xl-2 col-md-3 offset-md-1 pt-md-2 col-12 col-form-label">Phone Number</div>
                    <div class="col-xl-4 col-md-6 col-12">
                        <ul class="contact-list p-0 mb-0">
                            <li class="row"
                                *ngFor="let itemrow of userProfileForm.controls.newPhones.controls; let i = index"
                                [formGroupName]="i">
                                <div class="form-group contact-no col-xl-12 col-md-12 pr-0">
                                    <input type="text" class="form-control float-left"
                                           [ngClass]="{'error-message':showPhoneErrMsg}"
                                           placeholder=" Phone Number" type="text" formControlName="phoneNo"
                                           (keypress)="restrictBackspace($event)"
                                           (keyup)="checkUserEnteredData()" oncopy="return false" onpaste="return false"
                                           [value]="itemrow?.get('phoneNo')?.value | phoneNo"
                                           pattern="^\d{3}[\-]\d{3}[\-]\d{4}$" required maxlength="12">
                                    <select class="form-control float-left"
                                            [ngClass]="{'error-message':showPhoneErrMsg}" formControlName="phoneType"
                                            required
                                            (change)="updateMobileType(itemrow?.get('phoneNo')?.value,itemrow?.get('phoneType')?.value,'change');checkUserEnteredData()">
                                        <option value="" selected>Select Type</option>
                                        <option value="Mobile">Mobile</option>
                                        <option value="Home">Home</option>
                                        <option value="Work">Work</option>
                                    </select>
                                    <span class="fa fa-angle-down"></span>
                                    <span class="icon-Group-3646"
                                          (click)="removeContact(i,itemrow?.get('phoneNo')?.value,itemrow?.get('phoneType')?.value)"
                                          [hidden]="userProfileForm.controls.newPhones.length==1"></span>
                                </div>
                                <div class="col-12 mb-3 d-xl-none"
                                     *ngIf="primaryMobile == itemrow?.get('phoneNo')?.value && primaryMobile != '' && (itemrow?.get('phoneNo')?.value != '' && itemrow?.get('phneType')?.value ) != '' && !optOutSmsAlert && textNotificationSelected">
                                    This phone number is currently enrolled in text alertso
                                </div>
                            </li>
                        </ul>
                        <div>
                            <p *ngIf="showPhoneErrMsg" class="text-danger d-block mb-2">{{ showPhoneErrMsg }}</p>
                            <p *ngIf="errorMsg" class="text-danger d-md-block mb-2">{{ errorMsg }}</p>
                            <a (click)="addContact()" *ngIf="userProfileForm.controls.newPhones.controls.length<4"
                               class="primary-textcolor"><img
                                    src="../../assets/images/icons/add-policy.svg" class="mr-2"
                                    style="width:25px;height:25px" alt="add policy"> Add phone</a>
                        </div>
                        <br>

                        <div class="row">
                            <div class="offset-md-1 col-md-11 col-lg-10 offset-lg-2">
                                <button class="btn btn-primary mr-2"
                                        [disabled]="ChangeOccurence == 0 && ((phoneNumberOccurence == userProfileForm.controls['newPhones'].value.length)&& userDetails.phones.length == userProfileForm.controls['newPhones'].value.length)"
                                        (click)="cancelChangesInEmailPhone()">Cancel
                                </button>
                                <button class="btn btn-primary"
                                        [disabled]="ChangeOccurence == 0 && ((phoneNumberOccurence == userProfileForm.controls['newPhones'].value.length)&& userDetails.phones.length == userProfileForm.controls['newPhones'].value.length)"
                                        (click)="phoneNumNotification('save')">Save
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-5 d-none d-xl-flex col-12">
                        <ul class="primaryNo-notifier pl-4 pr-0 mb-0">
                            <li class="justify-content-start mb-3"
                                *ngFor="let itemrow of userProfileForm.controls.newPhones.controls; let i = index">
                                <div *ngIf="primaryMobile == itemrow?.get('phoneNo')?.value && primaryMobile != '' && (itemrow?.get('phoneNo')?.value != '' && itemrow?.get('phoneType')?.value ) != '' && !optOutSmsAlert && textNotificationSelected">
                                    This phone number is currently enrolled in text alerts
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </form>
        </accordion-group>
        <accordion-group [panelClass]="profileSection" class="mb-4 preferences" [isOpen]="panelList[1].value"
                         (isOpenChange)="onPanelValueChange($event, 1)" #myPreferences>
            <div accordion-heading class="clearfix">
                <span class="accordion-heading primary-textcolor"> My Preferences </span>
                <span [ngClass]="!myPreferences?.isOpen ? 'icon-open': 'icon-close'"
                      class="d-md-inline-block float-right"></span>
            </div>
            <div class="row">
                <div class="col-12 notifs-overlay pt-0">
                    <div class="row">
                        <div class="col-md-3 offset-md-9 col-xl-2 offset-xl-10">
              <span class="all-alerts pl-0 d-md-inline-block float-right d-flex"
                    [hidden]="myPreferences.isOpen == true">All
                Alerts
                <label class="switch ml-3">
                  <input type="checkbox" (change)="alertTypeForMsg = 'All';changeAllalerts(allAlerts)" name="allAlerts"
                         [checked]="allAlerts" [(ngModel)]="allAlerts">
                  <span class="slider"></span>
                </label>
              </span>
                        </div>
                        <div class="col-12 pb-2">
                            <div class="col-12 p-0">
                                <div class="primary-details d-md-none">
                                    <div class="icon-email primary-textcolor mb-2 pl-4"><span
                                            class="pl-4 d-block">{{ primaryEmail }}</span>
                                    </div>
                                    <div *ngIf="preferredMobile" class="primary-textcolor mt-3"><img
                                            src="../../assets/images/icons/phone.svg" alt="phone"
                                            class="mr-2" style="width:20px"><span
                                            class="pl-3">{{ preferredMobile }}</span>
                                    </div>
                                    <p class="mb-0">Manage Notifications</p>
                                </div>
                                <div class="row notifs-list-header pt-2 pb-2">
                                    <div class="col-xl-3 col-md-6 col-lg-6 col-12 mb-3 mb-md-0">
                                        <div class="row">
                                            <div class="offset-6 col-3 text-center">Email</div>
                                            <div class="col-3 text-center">Text</div>
                                        </div>
                                    </div>
                                    <div class="col-xl-3 col-md-6 col-lg-6 d-md-block d-none">
                                        <div class="row">
                                            <div class="offset-md-6 col-md-3 text-center"> Email</div>
                                            <div class="col-md-3 text-center"> Text</div>
                                        </div>
                                    </div>

                                </div>

                                <div class="row pb-4">
                                    <div class="col-xl-3 col-md-6 col-lg-6">
                                        <div class="row">
                                            <div class="col-6 alert-headers">Profile Alerts</div>
                                            <div class="col-3 toggle-buttons">
                                                <label class="switch" [ngClass]="optOutSmsAlert ? 'switch-disable': ''">
                                                    <input type="checkbox"
                                                           [checked]="userProfileData?.accountAlerts.email"
                                                           (change)="checkPreferenceConditions('','profileAlert','email',$event)"
                                                           name="accountAlertsEmail" [(ngModel)]="accountAlertsEmail"
                                                           [disabled]="!this.isMobileExist || optOutSmsAlert">
                                                    <span class="slider"></span>
                                                </label>
                                            </div>
                                            <div class="col-3 toggle-buttons">
                                                <label class="switch"
                                                       [ngClass]="optOutSmsAlert || !isMobileExist ? 'switch-disable': ''">
                                                    <input type="checkbox" *ngIf="!optOutSmsAlert"
                                                           [checked]="userProfileData?.accountAlerts.text"
                                                           (change)="alertTypeForMsg = 'Profile';checkPreferenceConditions('','profileAlert','text',$event)"
                                                           name="accountAlertsText" [(ngModel)]="accountAlertsText">
                                                    <span class="slider"></span>
                                                </label>
                                            </div>
                                            <p class="d-md-none mb-desc pl-3">You’ll receive alerts related to user
                                                profile changes, password
                                                changes, and change in mobile number or email</p>
                                        </div>
                                    </div>
                                    <div class="col-xl-3 col-md-6 col-lg-6">
                                        <div class="row">
                                            <div class="col-6 alert-headers">Opportunity Alerts
                                            </div>
                                            <div class="col-3 toggle-buttons">
                                                <label class="switch">
                                                    <input type="checkbox" [checked]="userProfileData?.oppAlerts.email"
                                                           (change)="checkPreferenceConditions('','','',$event)"
                                                           name="oppAlertsEmail" [(ngModel)]="oppAlertsEmail">
                                                    <span class="slider"></span>
                                                </label>
                                            </div>
                                            <div class="col-3 toggle-buttons">
                                                <label class="switch">
                                                    <input type="checkbox" *ngIf="!optOutSmsAlert"
                                                           [checked]="userProfileData?.oppAlerts.text"
                                                           (change)="alertTypeForMsg = 'Opportunity';checkPreferenceConditions('','','text',$event)"
                                                           name="oppAlertsText" [(ngModel)]="oppAlertsText">
                                                    <span class="slider"></span>
                                                </label>
                                            </div>
                                            <p class="d-md-none mb-desc pl-3">You’ll receive alerts related to savings
                                                opportunity, new
                                                announcements, offers</p>
                                        </div>
                                    </div>
                                    <div class="col-xl-2 d-none d-xl-block">
                                        <div class="w-100">
                                            <div *ngIf="preferredMobile" class="text-left primary-textcolor pl-2"><img
                                                    src="../../assets/images/icons/phone.svg"
                                                    class="mr-2 phone" alt="phone"> {{ preferredMobile }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xl-4 d-none d-xl-flex pt-md-2">
                                        <div class="w-100">
                                            <div class="text-left icon-email primary-textcolor">{{ primaryEmail }}</div>
                                        </div>
                                    </div>
                                </div>
                                <!--Medium and large devices-->

                                <div class="row d-none d-md-flex d-lg-flex d-xl-none py-2">
                                    <div class="col-md-5 col-lg-5">
                                        <div class="row">
                                            <div class="col">Contact Number</div>
                                            <div *ngIf="primaryMobile"
                                                 class="col text-left primary-textcolor">{{ primaryMobile }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-7 col-lg-7">
                                        <div class="row">
                                            <div class="col-md-3 col-lg-2 pl-0">Email:</div>
                                            <div class="col-md-9 col-lg-10 text-left primary-textcolor"> {{ primaryEmail }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <accordion [closeOthers]="false">
                        <accordion-group *ngIf="activePolicies.length"
                            class="policy-group mb-3" [isOpen]="true" #myActivePolicyPreferences>
                            <div accordion-heading class="clearfix">
                                <span class="accordion-heading primary-textcolor">Active Policy Preferences</span>
                                <span [ngClass]="!myActivePolicyPreferences?.isOpen ? 'icon-open': 'icon-close'" class="d-md-inline-block float-right"></span>
                            </div>
                            <div class="row">
                                <div class="col-md-12 preferences-records bg-white">
                                    <div class="policy-thumbnail mb-4 pb-2 pb-md-0 bg-white"
                                        *ngFor="let policies of activePolicies;let i=index">
                                        <p class="primary-textcolor policy-num">Policy: {{ policies.policyNum }}</p>
                                        <div class="row notifs-list-header d-md-flex d-none pb-2">
                                            <div class="col-md">
                                                <div class="row lg-text">
                                                    <div class="offset-md-6 col-md-3 text-left"> Email</div>
                                                    <div class="col-md-3 text-left"> Text</div>
                                                </div>
                                            </div>
                                            <div class="col-md">
                                                <div class="row lg-text">
                                                    <div class="offset-md-6 col-md-3 text-left"> Email</div>
                                                    <div class="col-3 text-left"> Text</div>
                                                </div>
                                            </div>
                                        </div>
        
                                        <div class="row notifs-list">
                                            <div class="col-md">
                                                <div class="row">
                                                    <div class="col-6 alert-headers">Policy Alerts<sup>&lowast;</sup></div>
                                                    <div class="col-3 toggle-buttons p-0">
                                                        <label class="switch">
                                                            <input type="checkbox" [checked]="policies.policyAlert.email"
                                                                (change)="alertTypeForMsg = 'Policy';checkPreferenceConditions(policies.policyNum,'policyAlert', 'email', $event)"
                                                                name="activePolicyAlertEmail{{i}}">
                                                            <span class="slider"></span>
                                                        </label>
                                                    </div>
                                                    <div class="col-3 toggle-buttons p-0">
                                                        <label class="switch">
                                                            <input type="checkbox" *ngIf="!optOutSmsAlert"
                                                                [checked]="policies.policyAlert.text"
                                                                (change)="checkPreferenceConditions(policies.policyNum,'policyAlert','text', $event)"
                                                                name="policies.policyAlert.text">
                                                            <span class="slider"></span>
                                                        </label>
                                                    </div>
                                                    <div class="offset-right-md-2 col-md-10 py-3 py-md-0 notifs-desc">
                                                        You’ll receive alerts related to new policy documents, policy expiration, 
                                                        policy renewal and payment reminders.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md">
                                                <div class="row">
                                                    <div class="col-6 alert-headers">Claims Alerts</div>
                                                    <div class="col-3 toggle-buttons p-0">
                                                        <label class="switch">
                                                            <input type="checkbox" [checked]="policies.claimAlert.email"
                                                                (change)="checkPreferenceConditions(policies.policyNum,'claimAlert','email', $event)"
                                                                name="policies.claimAlert.email">
                                                            <span class="slider"></span>
                                                        </label>
                                                    </div>
                                                    <div class="col-3 toggle-buttons p-0">
                                                        <label class="switch">
                                                            <input type="checkbox" *ngIf="!optOutSmsAlert"
                                                                [checked]="policies.claimAlert.text"
                                                                (change)="alertTypeForMsg = 'Claims';checkPreferenceConditions(policies.policyNum,'claimAlert','text', $event)"
                                                                name="policies.claimAlert.text">
                                                            <span class="slider"></span>
                                                        </label>
                                                    </div>
                                                    <div class="offset-right-md-4 col-md-8 py-md-0 py-3 notifs-desc">
                                                        You’ll receive alerts related to claims.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </accordion-group>

                        <accordion-group *ngIf="inactivePolicies.length"
                            class="policy-group" [isOpen]="false" #myInactivePolicyPreferences>
                            <div accordion-heading class="clearfix">
                                <span class="accordion-heading primary-textcolor">Inactive Policy Preferences</span>
                                <span [ngClass]="!myInactivePolicyPreferences?.isOpen ? 'icon-open': 'icon-close'"
                                    class="d-md-inline-block float-right"></span>
                            </div>
                            <div class="row">
                                <div class="col-md-12 preferences-records bg-white">
                                    <div class="policy-thumbnail mb-4 pb-2 pb-md-0 bg-white"
                                        *ngFor="let policies of inactivePolicies;let i=index">
                                        <p class="primary-textcolor policy-num">Policy: {{ policies.policyNum }}</p>
                                        <div class="row notifs-list-header d-md-flex d-none pb-2">
                                            <div class="col-md">
                                                <div class="row lg-text">
                                                    <div class="offset-md-6 col-md-3 text-left"> Email</div>
                                                    <div class="col-md-3 text-left"> Text</div>
                                                </div>
                                            </div>
                                            <div class="col-md">
                                                <div class="row lg-text">
                                                    <div class="offset-md-6 col-md-3 text-left"> Email</div>
                                                    <div class="col-3 text-left"> Text</div>
                                                </div>
                                            </div>
                                        </div>
        
                                        <div class="row notifs-list">
                                            <div class="col-md">
                                                <div class="row">
                                                    <div class="col-6 alert-headers">Policy Alerts<sup>&lowast;</sup></div>
                                                    <div class="col-3 toggle-buttons p-0">
                                                        <label class="switch">
                                                            <input type="checkbox" [checked]="policies.policyAlert.email"
                                                                (change)="alertTypeForMsg = 'Policy';checkPreferenceConditions(policies.policyNum,'policyAlert', 'email', $event)"
                                                                name="inactivePolicyAlertEmail{{i}}">
                                                            <span class="slider"></span>
                                                        </label>
                                                    </div>
                                                    <div class="col-3 toggle-buttons p-0">
                                                        <label class="switch">
                                                            <input type="checkbox" *ngIf="!optOutSmsAlert"
                                                                [checked]="policies.policyAlert.text"
                                                                (change)="checkPreferenceConditions(policies.policyNum,'policyAlert','text', $event)"
                                                                name="policies.policyAlert.text">
                                                            <span class="slider"></span>
                                                        </label>
                                                    </div>
                                                    <div class="offset-right-md-2 col-md-10 py-3 py-md-0 notifs-desc">
                                                        You’ll receive alerts related to new policy documents, policy expiration, 
                                                        policy renewal and payment reminders.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md">
                                                <div class="row">
                                                    <div class="col-6 alert-headers">Claims Alerts</div>
                                                    <div class="col-3 toggle-buttons p-0">
                                                        <label class="switch">
                                                            <input type="checkbox" [checked]="policies.claimAlert.email"
                                                                (change)="checkPreferenceConditions(policies.policyNum,'claimAlert','email', $event)"
                                                                name="policies.claimAlert.email">
                                                            <span class="slider"></span>
                                                        </label>
                                                    </div>
                                                    <div class="col-3 toggle-buttons p-0">
                                                        <label class="switch">
                                                            <input type="checkbox" *ngIf="!optOutSmsAlert"
                                                                [checked]="policies.claimAlert.text"
                                                                (change)="alertTypeForMsg = 'Claims';checkPreferenceConditions(policies.policyNum,'claimAlert','text', $event)"
                                                                name="policies.claimAlert.text">
                                                            <span class="slider"></span>
                                                        </label>
                                                    </div>
                                                    <div class="offset-right-md-4 col-md-8 py-md-0 py-3 notifs-desc">
                                                        You’ll receive alerts related to claims.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </accordion-group>
                    </accordion>

                    <div class="offset-right-md-2 col-md-12 pt-3 text-danger smsAlertMsg" *ngIf="optOutSmsAlert">Our
                        records
                        indicate that you have replied STOP to opt out of receiving text alerts. To resume your text
                        alerts, please
                        text keyword <strong>THIGALERTS</strong> to <strong>77453</strong> from your mobile device
                        ({{ primaryMobile }}). If you would like to update your mobile number, <span class="openProfile"
                                                                                                     (click)="navigateBetweenTabs(1, 0)">click
              here</span>.
                    </div>
                    <div class="offset-right-md-2 col-md-12 pt-3 help-text">
                        <sup>&lowast;</sup> Policy alerts are mandatory
                        <br>Enjoy the convenience of receiving updates on your claims and policy delivered on your
                        mobile phone.
                        Message & data rates may apply. Message frequency varies by account and preferences. Reply STOP
                        to cancel
                        or HELP for assistance.
                    </div>
                </div>
            </div>
        </accordion-group>
        <accordion-group [panelClass]="profileSection" class="mb-4 change-password" [isOpen]="panelList[2].value"
                         (isOpenChange)="onPanelValueChange($event, 2)" #changePswd>
            <div accordion-heading class="clearfix">
                <span class="accordion-heading primary-textcolor"> Change Password</span>
                <span [ngClass]="!changePswd?.isOpen ? 'icon-open': 'icon-close'" class="float-right"></span>
            </div>
            <form [formGroup]="changePasswordForm" (ngSubmit)="changePassword()">
                <div class="form-group row">
                    <div class="col-xl-2 offset-md-1 col-12 col-form-label col-md-3"> Current Password</div>
                    <div class="col-xl-4 col-12 col-md-6">
                        <input type="{{passwordControl.currentPassword.type}}" class="form-control w-100 pl-3"
                               name="oldPassword"
                               formControlName="oldPassword" placeholder="Enter Current Password"
                               (keypress)="restrictBackspace($event)">
                        <span class="icon-showpwd toggle-icon" *ngIf="changePasswordForm.value.oldPassword != ''"
                              (click)="toggleShow('currentPassword')"
                              [ngClass]="passwordControl.currentPassword.showCurrentpswdIcon ? 'icon-showpwd': 'icon-hidepwd'"></span>
                        <div class="text-danger"
                             *ngIf="changePasswordFormSubmitted && changePasswordForm.controls['oldPassword'].hasError('required')">
                            This is required field
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl-2 offset-md-1 col-md-3 col-12 col-form-label">Enter New Password</div>
                    <div class="col-xl-4  col-md-6">
                        <input type="{{passwordControl.changePassword.type}}" class="form-control w-100 pl-3"
                               name="newPassword"
                               formControlName="newPassword" placeholder="Enter New Password"
                               (keyup)="validatePassword($any($event.target).value)"
                               (keypress)="validatePassword($any($event.target).value);restrictBackspace($event);">
                        <span class="icon-showpwd toggle-icon" *ngIf="changePasswordForm.value.newPassword != ''"
                              [ngClass]="passwordControl.changePassword.showChangePswdIcon ? 'icon-showpwd': 'icon-hidepwd'"
                              (click)="toggleShow('newPassword')"></span>
                        <div class="text-danger"
                             *ngIf="changePasswordFormSubmitted && changePasswordForm.controls['newPassword'].hasError('required')">
                            This is required field
                        </div>
                    </div>
                    <div class="col-xl-4 offset-xl-0 offset-md-4 col-md-8 col-12">
                        <div>
                            <ul class="password-errors pl-0 pt-3">
                                <li class="d-table-row p-2">
                                    <i class="fa fa-close wrong" [ngClass]="{'fa fa-close wrong' : changePasswordForm.hasError('newPassword') || !(changePasswordForm.controls['oldPassword'].value) || !(changePasswordForm.controls['newPassword'].value),
                    'fa fa-check correct' : !(changePasswordForm.controls['newPassword'].hasError('required') && changePasswordForm.controls['newPassword'].hasError('minlength'))}"></i>Old
                                    password and new password should not be same
                                </li>
                                <li class="d-table-row p-2">
                                    <i class="fa fa-close wrong" [ngClass]="{'fa fa-close wrong' : changePasswordForm.controls['newPassword'].hasError('minlength')|| !changePasswordForm.controls['newPassword'].value,
                    'fa fa-check correct' : !(changePasswordForm.controls['newPassword'].hasError('required') && changePasswordForm.controls['newPassword'].hasError('minlength'))}"></i>Minimum
                                    of 8 characters
                                </li>
                                <li class="d-table-row p-2">
                                    <i class="fa fa-close wrong" [ngClass]="{'fa fa-close wrong' : !checkPswd || !changePasswordForm.controls['newPassword'].value,
                                                              'fa fa-check correct' : !(changePasswordForm.controls['newPassword'].hasError('required') && checkPswd)}"></i>At
                                    least 3 of the following types of characters: lowercase letters, uppercase letters,
                                    numbers and
                                    special characters; excluding >, <, and spaces
                                </li>
                                <li class="d-table-row p-2">
                                    <i class="fa fa-close wrong" [ngClass]="{'fa fa-close wrong' :  changePasswordForm.hasError('MatchPassword')|| !changePasswordForm.controls['newPassword'].value,
                    'fa fa-check correct' : !(changePasswordForm.controls['newPassword'].hasError('required') && changePasswordForm.hasError('MatchPassword'))}"></i>Password
                                    and re-typed password should match
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl-2 col-md-3 offset-md-1 col-12 col-form-label">Confirm New Password</div>
                    <div class="col-xl-4 col-md-6 col-12">
                        <input type="{{passwordControl.confirmPassword.type}}" class="form-control w-100 pl-3"
                               name="confirmNewPassword"
                               formControlName="confirmNewPassword" placeholder="Confirm New Password"
                               (keypress)="restrictBackspace($event)">
                        <span class="icon-showpwd toggle-icon" *ngIf="changePasswordForm.value.newPassword != ''"
                              [ngClass]="passwordControl.confirmPassword.showConfirmPswdIcon ? 'icon-showpwd': 'icon-hidepwd'"
                              (click)="toggleShow('confirmPassword')"></span>
                        <div class="text-danger"
                             *ngIf="changePasswordFormSubmitted && changePasswordForm.controls['confirmNewPassword'].hasError('required')">
                            This is required field
                        </div>
                        <div></div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class=" offset-lg-8  offset-md-2 col-md-8 col-lg-2 text-right offset-xl-5">
                        <button class="btn btn-primary" type="submit">Save</button>
                    </div>
                </div>
                <div class="row">
                    <div class=" offset-md-4 col-md-8 offset-xl-3 col-xl-9">
                        <span class="text-danger py-2 pt-2"
                              *ngIf="changePasswordErrMsg">{{ changePasswordErrMsg }}</span>
                    </div>
                </div>

            </form>
        </accordion-group>
        <accordion-group [panelClass]="profileSection" class="mb-4 edocs-section" [isOpen]="panelList[3].value"
                         (isOpenChange)="onPanelValueChange($event, 3)" #edocs>
            <div accordion-heading class="clearfix">
                <span class="accordion-heading primary-textcolor">eDocs Enrollment</span>
                <span class="float-right" [ngClass]="!edocs?.isOpen ? 'icon-open': 'icon-close'"></span>
            </div>
            <div class="row">
                <div class="w-48 policy-thumbnail mb-3 bg-white" *ngIf="eDocsDataEnrolled?.length">
                    <div class="row">
                        <div class="col">
                            <div class="policy-headers primary-textcolor mb-1">Enrolled Policies</div>
                            <div class="policy-subtext">
                                You are currently enrolled to receive these policy documents electronically.
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div *ngFor="let Edoc of eDocsDataEnrolled" class="d-flex mb-3">
                        <p-checkbox name="unenrollCheckbox" class="d-flex mr-2" [ngModel]="!Edoc.eDocsEnrolled"
                            (onChange)="changeEdocToUnenroll(Edoc.policyNumber, $event)" [binary]="true">
                        </p-checkbox>
                        <div class="policy-number">{{ Edoc.policyNumber }}</div>
                    </div>
                    <hr>
                    <button class="btn btn-primary mr-3" [disabled]="!selectedUnenroll.length"
                        (click)="eDocsWithdraw()">Unenroll</button>
                </div>
                <div class="w-48 policy-thumbnail mb-3 bg-white" *ngIf="eDocsDataUnenrolled?.length">
                    <div class="row">
                        <div class="col">
                            <div class="policy-headers primary-textcolor mb-1">Unenrolled Policies</div>
                            <div class="policy-subtext">
                                Enroll to receive policy documents electronically instead of by mail.
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div *ngFor="let Edoc of eDocsDataUnenrolled; let i = index" class="d-flex mb-3">
                        <p-checkbox name="enrollCheckbox" class="d-flex mr-2" [ngModel]="Edoc.eDocsEnrolled"
                            (onChange)="changeEdocToEnroll(Edoc.policyNumber, $event)" [binary]="true">
                        </p-checkbox>
                        <div class="policy-number">{{ Edoc.policyNumber }}</div>
                    </div>
                    <hr>
                    <div class="d-flex mb-3">
                        <p-checkbox class="d-flex mr-2"
                            [(ngModel)]="confirmedEdocsTandC" [value]="confirmedEdocsTandC"
                            (change)="$any($event.target).checked ? confirmedEdocsTandC = true : confirmedEdocsTandC = false"
                            [binary]="true"></p-checkbox>
                        <div>I have read and accept the <a
                            href="/api/termsandconditionsFile/EDOC/{{eDocsDataUnenrolled[0].address?.administrativeArea}}"
                            target="_blank">Terms &amp; Conditions</a>
                        </div>
                    </div>
                    <button class="btn btn-primary mr-3" [disabled]="!selectedEnroll.length || !confirmedEdocsTandC"
                        (click)="eDocsEnrollment()">Enroll</button>
                </div>
            </div>
        </accordion-group>
    </accordion>
</div>

<!--Select Modal-->
<div class="modal fade contacts-tracker bg-white mx-auto my-0" bsModal #contactsTracker="bs-modal">
    <h4 class="primary-textcolor text-center mb-4">Select One</h4>
    <p class="primary-textcolor text-center">Please select a mobile number to receive policy and claims related
        alerts</p>
    <div class="row">
        <ul class="phone-numbers col-12">
            <li class="row" *ngFor="let itemrow of mobileType; let i = index">
                <div class="form-group col-10 pr-0 mb-4">
                    <input class="form-control float-left" [value]="itemrow.phoneNo | phoneNo" readonly>
                    <input class="form-control float-left type-selector" [value]="itemrow.phoneType" readonly>
                </div>
                <div class="col-2">
                    <input type="radio" name="selectMobileNotify" [checked]="itemrow.notification == 'Y'"
                           (change)="changeSelectOption($any($event.target).value,itemrow.phoneNo)">
                </div>
            </li>
        </ul>
    </div>
    <div class="text-center">
        <button class="btn btn-primary mb-4" (click)="contactsTracker.hide();">Cancel</button>
        <button class="btn btn-primary mb-4 ml-3" (click)="updateUserProfile();contactsTracker.hide();">Continue
        </button>
    </div>
</div>

<!-- TP48174 Modals - STARTS -->
<div class="modal fade add-mobile-number bg-white mx-auto my-0" bsModal #addMobileNumber1="bs-modal">
    <div class="modal-body pt-0">
        <button type="button" class="iconClose cursor-pointer p-0 m-0 border-0 bg-white" data-dismiss="modal"
                aria-label="Close"
                (click)="getUserProfileData('getDetails');addMobileNumber1.hide()">
            <div class="glyph fs1 position-absolute">
        <span class="icon-Close">
          <span class="path1"></span><span class="path2"></span><span class="path3"></span>
        </span>
            </div>
        </button>
        <h4 class="primary-textcolor text-center mb-4"><img src="../../assets/images/icons/phone.svg"
                                                            alt="mobile number">Mobile Number
            Required</h4>
        <p class="px-4 text-center">A mobile number is required to enable text alerts</p>
        <button class="btn btn-primary"
                (click)="addMobileNumber1.hide();updatedMobileNumber = '';showAddMobileNumberError='';addMobileNumber2.show()">
            Add
            Mobile Number
        </button>
    </div>
</div>
<div class="modal fade add-mobile-number bg-white mx-auto my-0" bsModal #addMobileNumber2="bs-modal">
    <div class="modal-body pt-0">
        <button type="button" class="iconClose cursor-pointer p-0 m-0 border-0 bg-white" data-dismiss="modal"
                aria-label="Close"
                (click)="addMobileNumber2.hide();getUserProfileData('getDetails');updatedMobileNumber = '';showAddMobileNumberError=''">
            <div class="glyph fs1 position-absolute">
        <span class="icon-Close">
          <span class="path1"></span><span class="path2"></span><span class="path3"></span>
        </span>
            </div>
        </button>
        <h4 class="primary-textcolor text-center mb-4"><img src="../../assets/images/icons/phone.svg"
                                                            alt="add mobile number">Add Mobile Number</h4>
        <div class="form-group">
            <input class="form-control " type="text" placeholder="Mobile Number" maxlength="12"
                   [ngModel]="updatedMobileNumber | phoneNo"
                   (ngModelChange)="updatedMobileNumber = $event" [ngModelOptions]="{standalone: true}">
            <div class="text-danger pt-2" *ngIf="showAddMobileNumberError">
                {{ showAddMobileNumberError }}
            </div>
        </div>
        <button class="btn btn-primary" (click)="addMobileTypeNumber()" [disabled]="!updatedMobileNumber">Save</button>
    </div>
</div>
<div class="modal fade add-mobile-number bg-white mx-auto my-0" bsModal #addMobileNumber3="bs-modal">
    <div class="modal-body pt-0">
        <button type="button" class="iconClose cursor-pointer p-0 m-0 border-0 bg-white" data-dismiss="modal"
                aria-label="Close"
                (click)="addMobileNumber3.hide()">
            <div class="glyph fs1 position-absolute">
        <span class="icon-Close">
          <span class="path1"></span><span class="path2"></span><span class="path3"></span>
        </span>
            </div>
        </button>
        <h4 class="primary-textcolor text-center mb-4"><img src="../../assets/images/icons/phone.svg"
                                                            alt="mobile number added">Mobile Number Added</h4>
        <p class="px-4 text-center">Your mobile number has been saved and is now enrolled in {{ alertTypeForMsg }}
            alerts.</p>
        <button class="btn btn-primary" (click)="addMobileNumber3.hide()">Continue</button>
    </div>
</div>
<!-- TP48174 Modals - ENDS -->

<p class="footer-session">Host: {{ serverHostName }} :: Time: {{ serverTime }} :: Job: {{ serverJobName }}
    - {{ buildNumber }}
    :: SessionId: {{ usersessionId }}</p>
